import { api } from '../lib/client';
import { listDeployments } from './agent';

const DEFAULT_PAGE_SIZE = 200;

export async function fetchRegistrations() {
  const items = [];
  let nextOffset = 0;

  do {
    const { data } = await api.get('/phone-endpoints', {
      params: {
        type: 'phone-registration',
        offset: nextOffset,
        pageSize: DEFAULT_PAGE_SIZE
      }
    });
    items.push(...(data.items || []));
    nextOffset = data.nextOffset != null ? data.nextOffset : null;
  } while (nextOffset != null);

  return items;
}

export async function createRegistration(payload) {
  const body = {
    type: 'phone-registration',
    name: payload.name || undefined,
    registrar: payload.registrar,
    username: payload.username,
    password: payload.password,
    handler: payload.handler || undefined,
    outbound: payload.outbound ?? false,
    options: payload.options || undefined,
  };
  const { data } = await api.post('/phone-endpoints', body);
  return data;
}

export async function updateRegistration(id, payload) {
  const body = {};
  if (payload.name !== undefined) body.name = payload.name;
  if (payload.handler !== undefined) body.handler = payload.handler;
  if (payload.outbound !== undefined) body.outbound = payload.outbound;
  if (payload.options !== undefined) body.options = payload.options;
  if (payload.registrar !== undefined) body.registrar = payload.registrar;
  if (payload.username !== undefined) body.username = payload.username;
  if (payload.password !== undefined) body.password = payload.password;

  const { data } = await api.put(`/phone-endpoints/${encodeURIComponent(id)}`, body);
  return data;
}

export async function fetchRegistration(id) {
  const { data } = await api.get(`/phone-endpoints/${encodeURIComponent(id)}`);
  return data;
}

export async function activateRegistration(id) {
  const { data } = await api.post(`/phone-endpoints/${encodeURIComponent(id)}/activate`);
  return data;
}

export async function disableRegistration(id) {
  const { data } = await api.post(`/phone-endpoints/${encodeURIComponent(id)}/disable`);
  return data;
}

export async function deleteRegistration(id) {
  const { data } = await api.delete(`/phone-endpoints/${encodeURIComponent(id)}`);
  return data;
}

export async function fetchRegistrationDeployments() {
  const { items } = await listDeployments();
  return items || [];
}
